import axios from "axios";
//const url = "http://10.0.0.10:7357/";
//const url = "https://mobigo.aliquam.se:7357/";
const url = "https://sba.brandsakra.se:8889/";
//const url = config.VUE_CONFIG_API_ENDPOINT;


export function login(user, pass) {
  const params = new URLSearchParams({
    grant_type: "password",
    username: user,
    password: pass,
  });
  return axios.post(`${window.siteConfig.APIURL}token`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Oauth2",
    },
  });
}

export function refreshlogin(refresh_token) {
  const params = new URLSearchParams({
    grant_type: "refresh_token",
    Refresh_Token: refresh_token
  });
  return axios.post(`${window.siteConfig.APIURL}token`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Oauth2",
    },
  });
}

export async function API_GetMe() {
  const me = await axios.get(`${window.siteConfig.APIURL}api/users/me`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  return me
}

export async function API_PutCurrentCustomer(id) { 
  return axios.put(`${window.siteConfig.APIURL}api/users/customer`, {"CustomerId": id}, { 
    headers: { 
      "Content-Type": "application/json; charset=utf-8", 
      Authorization: "Bearer " + localStorage.getItem("token"), 
    }, 
  }); 
} 
 

export async function API_GetFinishedTasks() {
  const historyTasks = await axios.get(`${window.siteConfig.APIURL}api/tasks?filter.current=false`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  console.log(historyTasks)
  return historyTasks
}
export async function API_GetFinishedReport(taskId) {
  return await axios.get(`${window.siteConfig.APIURL}api/tasks/${taskId}/report`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}

export async function API_GetActiveTasks() {
  var e = await axios.get(`${window.siteConfig.APIURL}api/tasks?filter.current=true`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  console.log(e)
  return e
}
export async function API_GetInspectionTasks(id) {
  var e = await axios.get(`${window.siteConfig.APIURL}api/tasks/`+id, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  console.log(e)
  return e
}
export async function API_GetObjectLabels() {
  return await axios.get(`${window.siteConfig.APIURL}api/inspections/labels`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}

export function API_PostFinishedTask(taskId, json) {
  return axios.post(`${window.siteConfig.APIURL}api/inspections/${taskId}`, JSON.stringify(json), {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}

export async function API_GetInspections(locationId) {

  const result = await axios.get(`${window.siteConfig.APIURL}api/inspections/location/${locationId}/equipment`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  return result
}
export async function API_GetActiveInspections() {
  const result = await axios.get(`${window.siteConfig.APIURL}api/inspections/`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  return result
}
export async function API_UpdateInspectionRow(data, locationId) {
  const result = await axios.put(`${window.siteConfig.APIURL}api/inspections/row/${locationId}`,data, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  return result
}
export async function API_CompleteTask(inspectionId) {
  var json = {
    "Completed":true
  }
  const result = await axios.put(`${window.siteConfig.APIURL}api/inspections/${inspectionId}`,json, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
  return result
}


export async function API_ChangeMyPassword(json) {
  return axios.put(`${window.siteConfig.APIURL}api/users`, JSON.stringify(json), {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}

export async function API_Register(json) {
  return axios.put(`${window.siteConfig.APIURL}api/users`, JSON.stringify(json), {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  });
}


export async function API_Reset(json) {
  return axios.put(`${window.siteConfig.APIURL}api/users/reset`, JSON.stringify(json), {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  });
}
 
export function API_PostDocument(formdata) { 
  return axios.post(`${window.siteConfig.APIURL}api/documents`, formdata, { 
    headers: { 
      "Content-Type": "multipart/form-data", 
      //"Content-Type": "application/json; charset=utf-8", 
      Authorization: "Bearer " + localStorage.getItem("token"), 
    }, 
  }); 
} 
 
export async function API_GetDocuments() { 
  const documents = await axios.get(`${window.siteConfig.APIURL}api/documents`, { 
    headers: { 
      Authorization: "Bearer " + localStorage.getItem("token"), 
    }, 
  }); 
  return documents 
} 

export async function API_GetObjectInspections(locationId) { 
 
  const result = await axios.get(`${window.siteConfig.APIURL}api/inspections/objects/${locationId}`, { 
    headers: { 
      Authorization: "Bearer " + localStorage.getItem("token"), 
    }, 
  }); 
  return result 
}

export async function API_GetAllowedFileExtensions() { 
  const fileextensions = await axios.get(`${window.siteConfig.APIURL}api/documents/alloweduploadfileextensions`, { 
    headers: { 
      Authorization: "Bearer " + localStorage.getItem("token"), 
    }, 
  }); 
  return fileextensions 
} 
 